/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const networkInfrastructureEnumsFaultTypeOptionEnum = {
    Overload: 'Overload',
    UpdateFailure: 'UpdateFailure',
    Offline: 'Offline',
    HardwareFailure: 'HardwareFailure',
    Other: 'Other',
} as const;

export type NetworkInfrastructureEnumsFaultTypeOptionEnumKey =
    (typeof networkInfrastructureEnumsFaultTypeOptionEnum)[keyof typeof networkInfrastructureEnumsFaultTypeOptionEnum];

export type NetworkInfrastructureEnumsFaultTypeOption = NetworkInfrastructureEnumsFaultTypeOptionEnumKey;
